// ═══════════════════════════════════════════════════════════════════════════════
// Inventory photos persisted on a task instance — authed stream API paths
// (same endpoints as TaskReviewPage / latest home stock detail)
// ═══════════════════════════════════════════════════════════════════════════════

export type InventoryPersistedPhotoRef = {
  variant: 'v2Location' | 'stocktake';
  locationIndex: number;
  photoIndex: number;
};

export const buildInventoryPersistedPhotoApiPath = (
  taskInstanceId: string,
  ref: InventoryPersistedPhotoRef,
): string => {
  const base = `/api/task-instances/${encodeURIComponent(taskInstanceId)}`;
  if (ref.variant === 'v2Location') {
    return `${base}/inventory/v2/locations/${ref.locationIndex}/photos/${ref.photoIndex}`;
  }
  return `${base}/inventory/stocktake-photos/${ref.photoIndex}`;
};

export const resolveInventoryPersistedPhotoAuthedApiPath = (
  taskInstanceId: string | undefined,
  photos: Array<{ canonicalUrl: string; persistedPhotoRef?: InventoryPersistedPhotoRef }>,
  existingPhotoUrl: string,
): string | undefined => {
  if (!taskInstanceId) {
    return undefined;
  }
  const trimmedExisting = existingPhotoUrl.trim();
  const linked =
    trimmedExisting !== ''
      ? photos.find((photo) => photo.canonicalUrl.trim() === trimmedExisting)
      : undefined;
  const ref = linked?.persistedPhotoRef ?? photos.find((photo) => photo.persistedPhotoRef)?.persistedPhotoRef;
  if (!ref) {
    return undefined;
  }
  return buildInventoryPersistedPhotoApiPath(taskInstanceId, ref);
};
